<template>
  <div class="order-date">
    {{ $t('Fecha lanzamiento') }}:
    <router-link :to="createOrderDateLink('-')"
      :class="[ queryOrder ==  'fecha_salida-' ? 'active' : '']"><i class="fa fa-caret-down order-ico-size"></i></router-link>
    <span>|</span>
    <router-link :to="createOrderDateLink('+')"
      :class="[ queryOrder ==  'fecha_salida+' ? 'active' : '']"><i class="fa fa-caret-up order-ico-size"></i></router-link>
  </div>
</template>

<i18n>
{
  "es": {
    "Fecha lanzamiento": "Fecha lanzamiento"
  },
  "en": {
    
  },
  "ca": {
    "Fecha lanzamiento": "Data de llançament"
  }
}
</i18n>

<script>
  import { mapGetters } from 'vuex';

	export default {
		data: () => {
			return{
        order: 'fecha_salida+'
			}
		},
    computed:{
      ...mapGetters({ query: 'getQuery' }),
      queryOrder: function(){
        var tmp = Object.assign({}, this.query);
        return tmp.orden;
      }
    },
    methods: {
      createOrderDateLink(option){
        var tmp = Object.assign({}, this.query);
        return ( { query: Object.assign(tmp, { orden: 'fecha_salida'+option }) } );
      }
    },
    watch: {
      /*resultsPerPage: function() { 
        this.resultsPerPage = this.getResultsPerPage;
      }*/
    }
  }
</script>
